import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import "./BackButton.css";
import useWindowDimensions from "@mirage/hooks/useWindowDimensions";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";

export const BackButton = () => {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    if (history.length <= 1 || width < PublicPortalTheme.breakpoints.values.md) {
        return null;
    }
    return (
        <Button
            className="btn-back"
            variant="outlined"
            startIcon={<FontAwesomeIcon icon={faArrowLeft} style={PublicPortalTheme.icons.sizeS} />}
            onClick={() => {
                navigate(-1);
            }}
        >
            Back
        </Button>
    );
};
